export const timeZoneMap = {
    'EST': 'America/New_York',
    'CST': 'America/Chicago',
    'MST': 'America/Denver',
    'MST-Az': 'America/Phoenix',
    'PST': 'America/Los_Angeles',
    'HST': 'Pacific/Honolulu',
    'PHO': 'America/Phoenix'
};